import React from 'react';
import * as stylex from '@stylexjs/stylex';
import { NavLink } from "react-router-dom";
import { queryStringMod } from "nood-comp/src/util/converters/converters";
import Flex from "nood-comp/src/comp/ui/containers/Flex";
import Text from "nood-comp/src/comp/text/Text";
import FlexVertical from "nood-comp/src/comp/ui/containers/flex-boxes/FlexVertical";
import Tag from "nood-comp/src/comp/ui/tag/Tag";
import Icon from "nood-comp/src/comp/ui/feather-icon/Icon";
import Table from "nood-comp/src/comp/data/table/Table";
import ElapsedTime from "nood-comp/src/util/date/ElapsedTime";
export default function VoucherCodes(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    data_source: "/voucher-codes",
    rowPadding: 5,
    cols: [{
      property: "code",
      label: "Code",
      filterType: "text",
      icon: "tag",
      filterPlaceholder: "Code",
      width: 100,
      to: function to(obj, idx) {
        return queryStringMod({
          "do": "view",
          id: obj.id
        });
      },
      content: function content(obj) {
        return /*#__PURE__*/React.createElement(Flex, {
          gap: 8
        }, /*#__PURE__*/React.createElement(FlexVertical, null, /*#__PURE__*/React.createElement(Text, {
          weight: 600
        }, obj.code)));
      }
    }, {
      label: "Campaign",
      to: function to(obj, idx) {
        return queryStringMod({
          "do": "view",
          id: obj.campaign_id,
          pg: "campaigns"
        });
      },
      content: function content(obj) {
        return /*#__PURE__*/React.createElement(FlexVertical, null, /*#__PURE__*/React.createElement(Text, null, obj.campaign_code), /*#__PURE__*/React.createElement(Text, {
          size: 12,
          secondary: true
        }, obj.campaign_name));
      }
    }, {
      label: "Status",
      width: 90,
      property: "status",
      icon: "loader",
      filterType: "dropdown",
      dropdownFilterOptions: [{
        value: "REDEEMED",
        icon: "check",
        code: "REDEEMED"
      }, {
        value: "ACTIVE",
        icon: "loader",
        code: "ACTIVE"
      }, {
        value: "REVOKED",
        icon: "slash",
        code: "REVOKED"
      }],
      content: function content(obj) {
        var _obj$status, _statusColors$obj$sta;
        var statusColors = {
          ACTIVE: '#22c55e',
          REDEEMED: '#3b82f6',
          INVALID: '#ef4444'
        };
        return /*#__PURE__*/React.createElement(Tag, {
          value: (_obj$status = obj.status) !== null && _obj$status !== void 0 ? _obj$status : 'ACTIVE',
          color: (_statusColors$obj$sta = statusColors[obj.status]) !== null && _statusColors$obj$sta !== void 0 ? _statusColors$obj$sta : '#6b7280',
          textColor: "#fff",
          style: {
            fontSize: 11,
            padding: "2px 6px",
            borderRadius: 4,
            textTransform: "uppercase"
          }
        });
      }
    }, {
      label: "Redemptions",
      width: 110,
      content: function content(obj) {
        var _obj$redemptions_coun, _obj$max_redemption_c;
        return /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(React.Fragment, null, (_obj$redemptions_coun = obj.redemptions_count) !== null && _obj$redemptions_coun !== void 0 ? _obj$redemptions_coun : 0, " / ", (_obj$max_redemption_c = obj.max_redemption_count) !== null && _obj$max_redemption_c !== void 0 ? _obj$max_redemption_c : '?'));
      }
    }, {
      label: "Created",
      width: 70,
      content: function content(obj) {
        return /*#__PURE__*/React.createElement(ElapsedTime, {
          datetime: obj.created_at
        });
      }
    }, {
      width: 40,
      label: "",
      content: function content(obj) {
        return /*#__PURE__*/React.createElement(NavLink, {
          to: queryStringMod({
            "do": "edit",
            id: obj.id
          })
        }, /*#__PURE__*/React.createElement(Icon, {
          icon: "edit-2"
        }));
      }
    }]
  }));
}

// @ts-ignore